// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Price__Menu___1-CFa","MenuChessfilter":"Price__MenuChessfilter___3irvx","Title":"Price__Title___1bkqO","Inner":"Price__Inner___2PUsY","Inputs":"Price__Inputs___2Ly_2","Input":"Price__Input___1RqHZ","Dash":"Price__Dash___f2Q7c","Switcher":"Price__Switcher___UOqOb","Button":"Price__Button___Ey7UF","Show768":"Price__Show768___T4624","Hide768":"Price__Hide768___r-M-q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Price/Price.scss
// module id = 1402
// module chunks = 0